import { useAdminNavigation } from '@/contexts/AdminNavigationContext';
import { useMemo } from 'react';

const Admin = () => {
  const { tabs, activeTab } = useAdminNavigation();

  const ActiveTabComponent = useMemo(() => {
    return tabs?.find((tab) => tab.key === activeTab)?.component ?? null;
  }, [activeTab, tabs]);

  return (
    <div className="flex flex-col min-h-full">
      <div className="flex-1 p-4 sm:p-6 lg:px-8 max-w-full">
        {ActiveTabComponent ? <ActiveTabComponent /> : null}
      </div>
    </div>
  );
};

export default Admin;
